import React, { useEffect, useState } from 'react';

// iter-22: lightweight in-house Trustpilot-style review carousel.
//
// Operator directive: do NOT connect to the live Trustpilot widget /
// API. Render a static carousel with placeholder review content; the
// operator will swap REVIEWS for verbatim transcripts of their actual
// 5-star Trustpilot reviews in a follow-up iteration.
//
// All five reviews are 5-star. The carousel cross-fades through them on
// a 6-second cadence with a 400ms opacity transition. Reviewer date is
// intentionally omitted (per the spec — Trustpilot's TrustBox carousel
// can hide it; we simply don't render one). Avatar circle uses the
// reviewer's first-letter initial on a peach background to match the
// rest of the form's palette without pulling in profile photos.
//
// iter-26: classNames replace inline styles on responsive elements so
// the compact-mobile treatment from the doc spec ("Trustpilot section
// (compact mobile treatment)") can be applied via media queries in
// takeover.css. Body text gains a 3-line clamp (2 on mobile) plus a
// matching min-height so card outer dimensions are deterministic
// regardless of review length — this fixes the City-page shifting-
// form bug.
//
// iter-39: real Trustpilot reviews from ~/Downloads/Reviews
// transcribed verbatim (operator-supplied screenshots from
// profilepros.info Trustpilot page). All 5-star reviews, all GB
// reviewers; review counts + names + titles + bodies match the
// source exactly. If you need to swap one out, the next refresh of
// the operator's screenshots is the source of truth.
const REVIEWS = [
  {
    name: 'Emily Hucker',
    country: 'United Kingdom',
    reviewCount: 6,
    title: 'Amazing Company!',
    body: "Friendly and professional, always fixed problems (if there's any) when needed to! Lovely company definitely worth contacting them and working with them for sure :)",
  },
  {
    name: 'Brodie Cooke',
    country: 'United Kingdom',
    reviewCount: 1,
    title: 'Great company to work with',
    body: 'Great company to work with',
  },
  {
    name: 'kearnna delaney',
    country: 'United Kingdom',
    reviewCount: 3,
    title: 'brilliant do everything they say',
    body: 'brilliant do everything they say',
  },
  {
    name: 'Damon Keen',
    country: 'United Kingdom',
    reviewCount: 2,
    title: "I'm leaving a review I thought this…",
    body: "I'm leaving a review I thought this wasn't real till they send me the money for signing up. I hope people can read this and proceed with it and make a few pounds. Thanks guys for giving me this opportunity",
  },
  {
    name: 'Samantha Childs',
    country: 'United Kingdom',
    reviewCount: 10,
    title: 'They pay every month!',
    body: "They pay promptly on the first of every month without fail. It's so easy to get started and once done you can sit back and watch the money come in. Okay you won't get rich, but the extra every month comes in very handy!",
  },
  {
    name: 'Macauley Williams',
    country: 'United Kingdom',
    reviewCount: 2,
    title: 'Great company they do exactly what they…',
    body: 'Great company they do exactly what they say they will',
  },
  {
    name: 'CHARLOTTE PURSEY',
    country: 'United Kingdom',
    reviewCount: 6,
    title: 'Love it',
    body: 'Love it. Making a few extra quid and having fun while doing it.',
  },
  {
    name: 'Ricardo Martins',
    country: 'United Kingdom',
    reviewCount: 2,
    title: 'They are honest and keep them word',
    body: 'They are honest and keep them word',
  },
  {
    name: 'Marcin Vujanic',
    country: 'United Kingdom',
    reviewCount: 1,
    title: "I'm extremely happy with my payments",
    body: "I'm extremely happy with my payments",
  },
  {
    name: 'Dylan Ward',
    country: 'United Kingdom',
    reviewCount: 7,
    title: 'They do exactly as they say and have…',
    body: 'They do exactly as they say and have paid me on time or early every month since I started, trustworthy and helpful',
  },
  {
    name: 'Aileen Mclaren',
    country: 'United Kingdom',
    reviewCount: 9,
    title: 'Great company',
    body: 'Great company, always pay on time and its a simple process.',
  },
  {
    name: 'Real Jordie TV',
    country: 'United Kingdom',
    reviewCount: 1,
    title: 'Very good experience',
    body: 'Very good experience',
  },
  {
    name: 'Jaimie Anne-marie',
    country: 'United Kingdom',
    reviewCount: 37,
    title: 'I have had very good experiences with…',
    body: 'I have had very good experiences with prpfilepros and they always pay when they say they will. I am happy with them and I will continue to work with them going forward.',
  },
  {
    name: 'Lynne hull',
    country: 'United Kingdom',
    reviewCount: 1,
    title: 'This is not a scam, truly honest company every penny helps s me',
    body: "I join few months ago I wasn't sure at first but now have little money that comes in help me not much but ever penny helps me as I don't work. im glad I join.",
  },
  {
    name: 'Mo Khan',
    country: 'United Kingdom',
    reviewCount: 1,
    title: 'Amazing company',
    body: 'Amazing company. They always pay me on time and have not missed a day so far. I really recommend working with them if you want to earn a little extra cash.',
  },
  {
    name: 'Chelsea',
    country: 'United Kingdom',
    reviewCount: 1,
    title: 'Before joining i was abit sceptical but…',
    body: "Before joining i was abit sceptical but they pay every single month which is good to earn a little extra. You're always kept in the loop too.",
  },
  {
    name: 'Kai',
    country: 'United Kingdom',
    reviewCount: 2,
    title: 'Very friendly and helpful and always…',
    body: 'Very friendly and helpful and always pay on time',
  },
  {
    name: 'Lisa Atherton',
    country: 'United Kingdom',
    reviewCount: 14,
    title: "It is a great offer and it's good to…",
    body: "It is a great offer and it's good to try and they are fantastic, I would recommend anyone do it, they are very trusting also. I would like to thank them very much.",
  },
  {
    name: 'Orla',
    country: 'United Kingdom',
    reviewCount: 1,
    title: 'Pay you as soon as they say they will…',
    body: 'Pay you as soon as they say they will great company would definitely recommend',
  },
  {
    name: 'Jamie Simpson',
    country: 'United Kingdom',
    reviewCount: 1,
    title: 'It was a very good experience',
    body: 'It was a very good experience',
  },
];

const TRUSTPILOT_GREEN = '#00B67A';
const ROTATION_MS = 6000;
const FADE_MS = 400;

function TrustpilotStar() {
  return (
    <svg
      className="tp-star"
      viewBox="0 0 24 24"
      fill={TRUSTPILOT_GREEN}
      aria-hidden="true"
    >
      <path d="M12 2 L14.7 8.6 L21.8 9.3 L16.5 14 L18 21 L12 17.3 L6 21 L7.5 14 L2.2 9.3 L9.3 8.6 Z" />
    </svg>
  );
}

function TrustpilotLogoMark() {
  return (
    <svg
      className="tp-logomark"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <rect x="0" y="0" width="24" height="24" rx="4" fill={TRUSTPILOT_GREEN} />
      <path
        d="M12 4 L13.95 9.7 L20 9.7 L15.1 13.3 L17 19 L12 15.5 L7 19 L8.9 13.3 L4 9.7 L10.05 9.7 Z"
        fill="#fff"
      />
    </svg>
  );
}

export default function TrustpilotCarousel() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const tick = setInterval(() => {
      if (cancelled) return;
      setVisible(false);
      setTimeout(() => {
        if (cancelled) return;
        setIndex((i) => (i + 1) % REVIEWS.length);
        setVisible(true);
      }, FADE_MS);
    }, ROTATION_MS);
    return () => {
      cancelled = true;
      clearInterval(tick);
    };
  }, []);

  const review = REVIEWS[index];
  const initial = review.name.charAt(0).toUpperCase();

  return (
    <section className="trustpilot-carousel" aria-label="Trustpilot reviews">
      <div className="tp-header">
        <span className="tp-header-prefix">Reviewed on</span>
        <TrustpilotLogoMark />
        <span className="tp-wordmark">Trustpilot</span>
      </div>

      <div className="tp-card">
        <div
          className="tp-card-body"
          style={{
            opacity: visible ? 1 : 0,
            transition: `opacity ${FADE_MS}ms ease-in-out`,
          }}
        >
          <div className="tp-reviewer">
            <div className="tp-avatar" aria-hidden="true">
              {initial}
            </div>
            <div className="tp-reviewer-meta">
              <div className="tp-reviewer-name">{review.name}</div>
              <div className="tp-reviewer-sub">
                {review.country} &middot; {review.reviewCount} {review.reviewCount === 1 ? 'review' : 'reviews'}
              </div>
            </div>
          </div>

          <div className="tp-stars" aria-label="5 out of 5 stars">
            {[0, 1, 2, 3, 4].map((i) => (
              <TrustpilotStar key={i} />
            ))}
          </div>

          <div>
            <div className="tp-review-title">{review.title}</div>
            <div className="tp-review-body">{review.body}</div>
          </div>
        </div>
      </div>

      <div className="tp-dots" aria-hidden="true">
        {REVIEWS.map((_, i) => (
          <span
            key={i}
            className={`tp-dot${i === index ? ' tp-dot--active' : ''}`}
          />
        ))}
      </div>
    </section>
  );
}
